import styled from 'styled-components';
import { Paper } from '@material-ui/core';

export const Container = styled(Paper)`
  margin-bottom: ${props => props.theme.spacing(2)}px;
`;
